import { inject, observer } from 'mobx-react'
import type _Account from 'mobx/Account'
import React from 'react'
import styled from 'styled-components'
import { mediaQueriesBreakpoints } from 'styles/mixins'
import TypographyPro from 'themes/TypographyPro'
import { getTranslatedTextByKey } from 'utils/utils'

const Container = styled.div`
	display: flex;
	flex-direction: column;
	padding: 0 1.25rem;
	padding-top: 1rem;
	gap: 1.75rem;
	background: var(--optionalBackground);

	@media (${mediaQueriesBreakpoints.md}) {
		min-width: 15.625rem;
		height: fit-content;
		padding-bottom: 1rem;
		width: 25%;
	}

	margin: -1.75rem -0.62rem;

	@media ${mediaQueriesBreakpoints.xs} {
		margin: -1.75rem -1.25rem 0;
	}

	@media ${mediaQueriesBreakpoints.md} {
		margin: 0;
	}
`

const TitleContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.25rem;
	color: var(--strokeMenuTitle);
`

const NameTitle = styled(TypographyPro).attrs({ variant: 'h5' })`
	color: var(--strokeMenuTitle);
`

const WelcomeTitle = styled(TypographyPro).attrs({ variant: 'h4' })`
	color: var(--strokeMenuTitle);
`

const NavigationContainer = styled.div`
	display: flex;
	align-items: flex-start;
	width: fit-content;
	gap: 0.75rem;

	cursor: pointer;

	@media (${mediaQueriesBreakpoints.md}) {
		flex-direction: column;
	}
`

const NavigationTitleContainer = styled.div<{ active: boolean }>`
	color: var(--strokeMenuTitle);
	padding-bottom: 0.375rem;
	${({ active }) => `border-bottom: 3px solid ${active ? 'var(--topMenuLine)' : 'transparent'}`}
`
const NavigationTitle = styled(TypographyPro).attrs({ variant: 'BodyRegular' })``

export enum Tab {
	SPECIAL_OFFERS = 'SPECIAL_OFFERS',
	// TODO: In a future task, add this page
	// USED_OFFERS = 'USED_OFFERS',
}

const tabToString: Record<Tab, string> = {
	[Tab.SPECIAL_OFFERS]: 'Special Offers',
}

interface Props {
	tab: Tab
	setTab: React.Dispatch<React.SetStateAction<Tab>>
	Account?: typeof _Account
}

const CouponsHeader = ({ tab, setTab, Account }: Props) => (
	<Container>
		<TitleContainer>
			<span>
				<NameTitle>
					{getTranslatedTextByKey('hi', 'Hey')},&nbsp;{Account?.userName?.split(' ')[0]}!
				</NameTitle>
			</span>
			<WelcomeTitle data-testid="coupons-welcome-text">
				{getTranslatedTextByKey('eCommerce.coupons.navigation.welcome', 'Welcome to Coupon Wallet')}
			</WelcomeTitle>
		</TitleContainer>
		<NavigationContainer>
			{(Object.values(Tab) as Tab[]).map((value) => (
				<NavigationTitleContainer key={value} active={tab === value} onClick={() => setTab(value)}>
					<NavigationTitle>{getTranslatedTextByKey(`eCommerce.coupons.navigation.${value}`, tabToString[value])}</NavigationTitle>
				</NavigationTitleContainer>
			))}
		</NavigationContainer>
	</Container>
)

export default inject('Account')(observer(CouponsHeader))
